import { Inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { MessagingChannelKeys, MessagingChannelsConfig, MessagingChannelStats, WhatsappMessageTemplate } from './model'
import { map } from 'rxjs/operators'
import { BehaviorSubject } from 'rxjs'
import { CURRENT_ACCOUNT_ID, isSomething } from '@tokeet-frontend/tv3-platform'

export interface MessagingResponse<T> {
  http_code: string
  response: T
}

export interface PhoneAccount {
  archived: 0
  created: 1748877425
  pkey: '4d85bb6b-500c-4792-84f7-36cf9d970b8c-tk2'
  account: 1619621570.7932
  name: 'Custom Phone'
  phone: '@13133628353'
  status: 1
}

@Injectable()
export class MessagingChannelsService {
  constructor(private http: HttpClient, @Inject(CURRENT_ACCOUNT_ID) private accountId$: BehaviorSubject<number>) {}

  enableChannel(type: MessagingChannelKeys) {
    const url = `@api/v1/message/register-channels?account=${this.accountId$.value}`

    return this.http.post<MessagingResponse<{ success: true }>>(url, {
      account: String(this.accountId$.value),
      [type]: {
        enabled: true,
      },
    })
  }

  unsubscribe(channel: MessagingChannelKeys) {
    const url = `@api/v1/message/${channel}/unsubscribe`

    return this.http.delete(url)
  }

  loginChannel(type: MessagingChannelKeys, pageType?: 'business' | 'personal') {
    let url = `@api/v1/message/${type}/login?account=${this.accountId$.value}`
    if (isSomething(pageType)) {
      url = `${url}&type=${pageType}`
    }

    return this.http.get<MessagingResponse<string>>(url).pipe(map((t) => t.response))
  }

  fetchChannels() {
    const url = `@api/v1/message/channels`

    return this.http.get<MessagingResponse<MessagingChannelsConfig>>(url).pipe(map((r) => r.response))
  }

  getWhatsappTemplates() {
    const url = `@api/v1/message/templates?channel=whatsapp-twilio`

    return this.http
      .get<MessagingResponse<{ templates: WhatsappMessageTemplate[] }>>(url)
      .pipe(map((r) => r.response?.templates || []))
  }

  isWhatsappFreeMessageEnabled(guestId: string) {
    const url = `@api/v1/message/whatsapp/convo-started?guestId=${guestId}`

    return this.http
      .get<{ response: { status: string; data: { hasSentMessageWithin24Hours: boolean } } }>(url)
      .pipe(map((r) => r.response))
  }

  getChannelStats(channel: MessagingChannelKeys) {
    const url = `@api/v1/message/stats/?channel=${channel}`

    return this.http.get<{ response: { data: MessagingChannelStats } }>(url).pipe(map((r) => r.response?.data))
  }

  getPhoneAccount() {
    const url = `@api/phoneaccount/active`

    return this.http.get<PhoneAccount>(url)
  }

  cancelCustomPhone() {
    const url = `@api/unsubscribe/tokeet_messaging_custom_phone_v1`

    return this.http.delete(url)
  }
}
